import React, {useState} from 'react'
import {Dropdown, Input} from '@local/ui/components'
import {phoneCodes} from '@local/utils/phoneCodes'
import {cx} from '@local/utils/cx'
import {PHONE_PATTTERN} from '@local/utils/string'

type PhoneNumberInputProps = {
	onChange: (value: string) => void
	onInvalid: (e: React.FormEvent<HTMLInputElement>) => void
	hasError: boolean
	light?: boolean
}

const PhoneNumberInput = ({onChange, onInvalid, light, hasError}: PhoneNumberInputProps) => {
	const [countryCode, setCountryCode] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')
	const [isFocused, setIsFocused] = useState(false)

	const onNumberChange = (e) => {
		const number = e.target.value.replace(countryCode, '')
		setPhoneNumber(number)
		onChange(countryCode + e.target.value)
	}

	const optionsContainerBorder = light ? 'border-black' : isFocused ? 'border-grey-1' : 'border-grey-2'

	return (
		<div className={cx(
			'flex items-center col-span-2 w-full bg-transparent rounded-xxs border border-grey-2 peer-focus-visible:border-grey-1 focus:outline-none duration-300 ease-quart-out transition-colors',
			optionsContainerBorder)}>
			<Dropdown
				id='countryCode' name='countryCode' defaultValue={{label: '🇳🇱 +31', value: '+31'}} dropdownClassName={cx('border-b-0 border-t-0 border-l-0 border-r-1 rounded-none w-100')} placeholder='' options={phoneCodes} />
			<Input
				required
				variant={light ? 'light' : 'dark'}
				type='tel'
				name='phoneNumber'
				label='Phone Number'
				value={phoneNumber}
				onChange={onNumberChange}
				onInvalid={onInvalid}
				hasError={hasError}
				pattern={PHONE_PATTTERN}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				className='h-48 w-full border-none'
				inputClassName='h-full border-none'
				errorClassName='z-10 bg-grey-4'
				labelClassName={light ? 'bg-transparent' : 'bg-grey-4'} />
		</div>
	)
}

export default PhoneNumberInput
